import React from "react";
import {
  Document,
  Font,
  Image,
  Link,
  Page,
  StyleSheet,
  Text,
  View,
} from "@react-pdf/renderer";
import Application from "../../../../../database/models/application-form/srilanka/Application";
import ieee from "../../../../../shared/resources/insl-logo-1.png";
import { TeamRole } from "../../../../../shared/constants/Constant";

interface IProps {
  data: Data;
}

interface Data {
  fileName: string;
  application: Application;
}

const Preview = (props: IProps) => {
  const { application, fileName } = props.data;
  return (
    <Document>
      <Page style={styles.body}>
        <View style={styles.imageWrapper}>
          <Image style={styles.image} src={ieee} />
        </View>

        <Text style={styles.title}>IEEE Innovation Nation Sri Lanka 2021</Text>
        <Text style={styles.subtitle}>Pre-Accelerator</Text>

        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Team/Company Name:{" "}
            <Text style={styles.answer}>{application.teamName}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            INSL ID No: <Text style={styles.answer}>{application.inslId}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            Product/Project Name:
            <Text style={styles.answer}>{application.projectName}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What industry does your product/project fall under?
          </Text>
          {application.industries.map((ind, index) => (
            <Text key={index} style={styles.answer}>
              {ind}
            </Text>
          ))}
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What is the problem you are solving?
          </Text>
          <Text style={styles.answer}>{application.solvingProblem}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>How are you solving the problem?</Text>
          <Text style={styles.answer}>{application.solvingApproach}</Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>Why is This important to you?</Text>
          <Text style={styles.answer}>{application.importance}</Text>
        </View>
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>
            What stage are you at?{" "}
            <Text style={styles.answer}>{application.stage}</Text>
          </Text>
        </View>
        <View style={styles.fieldWrapperTwoline}>
          <Text style={styles.question}>
            What is the progress you have made so far?
          </Text>
          <Text style={styles.answer}>{application.projectProgress}</Text>
        </View>
        {application.pitchLink !== "" && (
          <View style={styles.fieldWrapperTwoline}>
            <Text style={styles.question}>Link to the pitch?</Text>
            <Link src={application.pitchLink} style={styles.link}>
              {application.pitchLink}
            </Link>
          </View>
        )}
        <View style={styles.fieldWrapperInline}>
          <Text style={styles.question}>Project Proposal: </Text>

          <Link src={application.proposalLink} style={styles.link}>
            {fileName}
          </Link>
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `[${pageNumber}]`}
          fixed
        />
      </Page>
      <Page style={styles.body}>
        <Text style={styles.subHeader}>Personal Info</Text>
        <Text style={styles.subHeaderTwo}>Team leader details</Text>
        <View style={{ marginLeft: 20 }}>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Full Name:{" "}
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.fullName)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Email Address:
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.email)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Name of University/Institute:
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.university)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Contact Number:{" "}
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.contact)}
              </Text>
            </Text>
          </View>
          <View style={styles.fieldWrapperInline}>
            <Text style={styles.question}>
              Province of Residence:{" "}
              <Text style={styles.answer}>
                {application.members
                  .filter((member) => member.role === TeamRole.LEADER)
                  .map((member) => member.resideProvince)}
              </Text>
            </Text>
          </View>
        </View>
        <View>
          {application.members
            .filter((member) => member.role === TeamRole.MEMBER)
            .map((member, index) => (
              <View key={index}>
                <Text style={styles.subHeaderTwo}>Team member {index + 1}</Text>
                <View style={{ marginLeft: 20 }}>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Full Name:
                      <Text style={styles.answer}>{member.fullName}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Email Address:{" "}
                      <Text style={styles.answer}>{member.email}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Name of University/Institute:{" "}
                      <Text style={styles.answer}>{member.university}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Contact Number:{" "}
                      <Text style={styles.answer}>{member.contact}</Text>
                    </Text>
                  </View>
                  <View style={styles.fieldWrapperInline}>
                    <Text style={styles.question}>
                      Province of Residence:{" "}
                      <Text style={styles.answer}>{member.resideProvince}</Text>
                    </Text>
                  </View>
                </View>
              </View>
            ))}
        </View>
        <Text
          style={styles.pageNumber}
          render={({ pageNumber }) => `[${pageNumber}]`}
          fixed
        />
      </Page>
    </Document>
  );
};

Font.register({
  family: "Oswald",
  src: "https://fonts.gstatic.com/s/oswald/v13/Y_TKV6o8WovbUd3m_X9aAA.ttf",
});

const styles = StyleSheet.create({
  body: {
    paddingTop: 10,
    paddingBottom: 65,
    paddingHorizontal: 35,
  },
  title: {
    fontSize: 24,
    color: "#00629b",
    textAlign: "center",
    fontFamily: "Oswald",
  },
  subtitle: {
    fontSize: 12,
    textAlign: "center",
    color: "#00629b",
    marginBottom: 10,
    paddingBottom: 10,
    borderBottomColor: "#333",
    borderBottomWidth: 1,
    borderColor: "#00629b",
  },
  fieldWrapperInline: {
    flexDirection: "row",
    alignContent: "flex-start",
    flexShrink: 1,
    margin: 10,
  },
  fieldWrapperTwoline: {
    flexDirection: "column",
    margin: 10,
  },
  subHeader: {
    margin: 10,
    fontWeight: 900,
    fontSize: 16,
    fontFamily: "Times-Bold",
  },
  subHeaderTwo: {
    margin: 10,
    fontWeight: 900,
    fontSize: 14,
    fontFamily: "Times-Bold",
  },
  question: {
    fontWeight: 900,
    fontSize: 12,
    fontFamily: "Times-Bold",
    marginRight: 5,
    marginBottom: 3,
  },
  answer: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    marginRight: 10,
    textAlign: "justify",
  },
  image: {
    width: 100,
    textAlign: "center",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  imageWrapper: {
    flexDirection: "row",
    justifyContent: "center",
  },
  link: {
    fontSize: 12,
    fontFamily: "Times-Roman",
    textAlign: "justify",
    color: "blue",
    textDecoration: "underline",
  },
});

export default Preview;
